module.exports = __webpack_public_path__ + "static/media/green-check-mark.4ffd2994.png";